import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import iconArrowUpGrey from "../../../images/icons/icon-arrow-up-grey.svg";

class CardFAQ extends PolymerElement {
  static get template() {
    return html`
      <style>
        .container {
          box-shadow: 0px 1px 10px rgba(66, 66, 66, 0.15);
          border-radius: 4px;
          padding: 16px;
          margin: 12px 0px;
        }
        h2 {
          margin: 0;
          font-size: 18px;
          color: #424242;
          max-width: 90%;
        }
        p {
          margin: 0;
        }
        .column {
          display: flex !important;
        }
        .beetween {
          align-items: flex-start;
          justify-content: space-between;
        }
        .show {
          display: block;
        }
        .hide {
          display: none;
        }
      </style>
      <div class="container">
        <div class="column beetween" on-click="handleCollapse">
          <h2>[[title]]</h2>
          <img src="[[iconArrowUpGrey]]" />
        </div>
        <div class$="[[collapse]]" inner-h-t-m-l="[[description]]"></div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconArrowUpGrey: {
        type: String,
        value: iconArrowUpGrey,
      },
      collapse: {
        type: String,
        value: "show",
      },
      title: {
        type: String,
      },
      description: {
        type: String,
      },
    };
  }

  handleCollapse() {
    this.collapse = this.collapse == "hide" ? "show" : "hide";
  }
}
customElements.define("card-faq", CardFAQ);
